// src/pages/Users.js
import React, { useEffect, useState } from 'react';
import api from '../utils/api';
import toast from 'react-hot-toast';

const ROLES = { admin:'ئەدمین', data_entry:'داخڵکەر', viewer:'بینەر', report:'ڕاپۆرت' };

export default function Users() {
  const [users, setUsers] = useState([]);
  const [depts, setDepts] = useState([]);
  const [modal, setModal] = useState(null);
  const [form, setForm] = useState({ username:'', password:'', full_name:'', role:'data_entry', department_id:'', is_active:true });

  const load = () => {
    api.get('/auth/users').then(r => setUsers(r.data));
    api.get('/departments').then(r => setDepts(r.data));
  };
  useEffect(load, []);

  const openNew = () => { setForm({ username:'', password:'', full_name:'', role:'data_entry', department_id:'', is_active:true }); setModal('new'); };
  const openEdit = (u) => { setForm({...u, password:''}); setModal('edit'); };

  const save = async () => {
    try {
      if (modal === 'new') await api.post('/auth/users', form);
      else await api.put(`/auth/users/${form.id}`, form);
      toast.success('بە سەرکەوتوویی تۆمارکرا');
      setModal(null);
      load();
    } catch (err) {
      toast.error(err.response?.data?.error || 'هەڵەیەک ڕووی دا');
    }
  };

  return (
    <div style={styles.page}>
      <div style={styles.topbar}>
        <h1 style={styles.title}>👥 بەکارهێنەران</h1>
        <button onClick={openNew} style={styles.newBtn}>➕ بەکارهێنەری نوێ</button>
      </div>

      <div style={styles.tableWrap}>
        <table style={styles.table}>
          <thead><tr style={styles.thead}>
            <th style={styles.th}>ناو</th>
            <th style={styles.th}>یوزەرنەیم</th>
            <th style={styles.th}>ڕۆڵ</th>
            <th style={styles.th}>بەش</th>
            <th style={styles.th}>دەستوور</th>
            <th style={styles.th}>کردار</th>
          </tr></thead>
          <tbody>
            {users.map(u => (
              <tr key={u.id} style={styles.tr}>
                <td style={styles.td}>{u.full_name}</td>
                <td style={styles.td}><code>{u.username}</code></td>
                <td style={styles.td}><span style={{...styles.roleBadge, background: {admin:'#1a5276',data_entry:'#1e8449',viewer:'#7d3c98',report:'#d35400'}[u.role]+'20', color:{admin:'#1a5276',data_entry:'#1e8449',viewer:'#7d3c98',report:'#d35400'}[u.role]}}>{ROLES[u.role]}</span></td>
                <td style={styles.td}>{u.dept_name || '—'}</td>
                <td style={styles.td}><span style={{...styles.status, background: u.is_active?'#eafaf1':'#fdecea', color: u.is_active?'#1e8449':'#e74c3c'}}>{u.is_active?'چالاک':'ناچالاک'}</span></td>
                <td style={styles.td}><button onClick={() => openEdit(u)} style={styles.editBtn}>✏️ دەستکاری</button></td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {modal && (
        <div style={styles.overlay}>
          <div style={styles.modal}>
            <h2 style={styles.modalTitle}>{modal==='new'?'بەکارهێنەری نوێ':'دەستکاری بەکارهێنەر'}</h2>
            <div style={styles.formGrid}>
              <div style={styles.field}><label style={styles.label}>ناوی تەواو</label>
                <input style={styles.inp} value={form.full_name} onChange={e=>setForm({...form,full_name:e.target.value})} /></div>
              <div style={styles.field}><label style={styles.label}>یوزەرنەیم</label>
                <input style={styles.inp} value={form.username} onChange={e=>setForm({...form,username:e.target.value})} disabled={modal==='edit'} /></div>
              <div style={styles.field}><label style={styles.label}>وشەی نهێنی {modal==='edit'&&'(بۆ گۆڕین بنووسە)'}</label>
                <input style={styles.inp} type="password" value={form.password} onChange={e=>setForm({...form,password:e.target.value})} /></div>
              <div style={styles.field}><label style={styles.label}>ڕۆڵ</label>
                <select style={styles.inp} value={form.role} onChange={e=>setForm({...form,role:e.target.value})}>
                  {Object.entries(ROLES).map(([k,v])=><option key={k} value={k}>{v}</option>)}
                </select></div>
              <div style={styles.field}><label style={styles.label}>بەش</label>
                <select style={styles.inp} value={form.department_id} onChange={e=>setForm({...form,department_id:e.target.value})}>
                  <option value="">--- هەڵبژێرە ---</option>
                  {depts.map(d=><option key={d.id} value={d.id}>{d.name_ku}</option>)}
                </select></div>
              {modal==='edit' && <div style={styles.field}><label style={styles.label}>دەستوور</label>
                <select style={styles.inp} value={form.is_active?'1':'0'} onChange={e=>setForm({...form,is_active:e.target.value==='1'})}>
                  <option value="1">چالاک</option><option value="0">ناچالاک</option>
                </select></div>}
            </div>
            <div style={styles.btnRow}>
              <button onClick={save} style={styles.saveBtn}>💾 تۆمارکردن</button>
              <button onClick={()=>setModal(null)} style={styles.cancelBtn}>❌ داخستن</button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
}

const styles = {
  page:{padding:20}, topbar:{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16},
  title:{fontSize:20,fontWeight:'bold',color:'#1a5276',margin:0},
  newBtn:{background:'linear-gradient(135deg,#1a5276,#2980b9)',color:'#fff',border:'none',borderRadius:8,padding:'10px 18px',fontSize:13,fontWeight:'bold',cursor:'pointer'},
  tableWrap:{background:'#fff',borderRadius:10,boxShadow:'0 2px 8px rgba(0,0,0,0.07)',overflow:'hidden'},
  table:{width:'100%',borderCollapse:'collapse'}, thead:{background:'#1a5276'},
  th:{color:'#fff',padding:'11px 12px',textAlign:'right',fontSize:12,fontWeight:'bold'},
  tr:{borderBottom:'1px solid #f0f0f0'}, td:{padding:'10px 12px',fontSize:13},
  roleBadge:{borderRadius:10,padding:'2px 10px',fontSize:11,fontWeight:'bold'},
  status:{borderRadius:10,padding:'2px 10px',fontSize:11},
  editBtn:{background:'#eaf2fb',color:'#1a5276',border:'1px solid #1a5276',borderRadius:6,padding:'4px 12px',cursor:'pointer',fontSize:12},
  overlay:{position:'fixed',inset:0,background:'rgba(0,0,0,0.5)',display:'flex',alignItems:'center',justifyContent:'center',zIndex:1000},
  modal:{background:'#fff',borderRadius:12,padding:28,width:480,maxWidth:'95vw',direction:'rtl'},
  modalTitle:{fontSize:16,fontWeight:'bold',color:'#1a5276',marginBottom:16},
  formGrid:{display:'grid',gridTemplateColumns:'1fr 1fr',gap:12,marginBottom:16},
  field:{display:'flex',flexDirection:'column',gap:4},
  label:{fontSize:12,fontWeight:'bold',color:'#555'},
  inp:{padding:'8px 10px',border:'1.5px solid #ddd',borderRadius:6,fontSize:13,fontFamily:'inherit'},
  btnRow:{display:'flex',gap:8,justifyContent:'flex-end'},
  saveBtn:{background:'#1a5276',color:'#fff',border:'none',borderRadius:6,padding:'9px 18px',cursor:'pointer',fontSize:13},
  cancelBtn:{background:'#f0f0f0',color:'#444',border:'none',borderRadius:6,padding:'9px 18px',cursor:'pointer',fontSize:13},
};
